import * as React from 'react';
import S from './TestimonialCard.styles';
import { getSrcs } from '@helpers/image';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
const TestimonialCard = ({ name, jobTitle, image, mobileImage, testimonial, supportingText, theme = 'yellow', }) => {
    const srcs = image ? getSrcs(image, 302, 218, 4) : [];
    const mobileSrcs = image ? getSrcs(mobileImage ?? image, 222, 175, 4) : [];
    return (React.createElement(S.Container, { "data-widget-theme": theme, "data-has-image": image ? true : false },
        React.createElement(S.Inner, null,
            React.createElement(S.MediaContainer, null,
                React.createElement(S.MediaHolder, null, image && (React.createElement(React.Fragment, null,
                    React.createElement(S.ImageDesktop, { alt: image?.altText ?? '', loading: "lazy", role: image?.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(',') }),
                    React.createElement(S.ImageMobile, { alt: mobileImage?.altText ?? '', loading: "lazy", role: mobileImage?.altText ? undefined : 'presentation', src: mobileSrcs[0].split(' ')[0], srcSet: mobileSrcs.join(',') })))),
                React.createElement(S.QuoteIconImageArea, null, getSvgFromSystem(SystemIcon.Quote))),
            React.createElement(S.ContentArea, null,
                React.createElement(S.ContentInner, null,
                    React.createElement(S.QuoteIconArea, null, getSvgFromSystem(SystemIcon.Quote)),
                    React.createElement(S.Title, null,
                        name,
                        " ",
                        jobTitle && `| ${jobTitle}`),
                    testimonial && React.createElement(S.Intro, null, testimonial),
                    supportingText && React.createElement(S.SupportText, null, supportingText))))));
};
export default TestimonialCard;
